import React from "react";
import { useLocalization } from "../../LocalizationContext";
import "./Header.css";
import Translate from "../../Translate"; // Импортируем CSS стили
import {useState} from "react";
import CustomSVG from "../CustomSVG/CustomSVG";
import { IoIosArrowBack } from "react-icons/io";



import FlagEN from "../../Assets/Flags/united-kingdom.png";
import FlagEE from "../../Assets/Flags/estonia.png";


const languages = {
    en: { label: "English", flag: FlagEN },
    ee: { label: "Eesti", flag: FlagEE },
};

const Header = ({setCurrentIndex, currentIndex,pages,h1TextId,h1DescriptionId}) => {
    const { switchLanguage } = useLocalization();
    const [selectedLang, setSelectedLang] = useState("en");
    const [isOpen, setIsOpen] = useState(false);

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + pages.length) % pages.length);
    };
    const handleLanguageChange = (lang) => {
        setSelectedLang(lang);
        switchLanguage(lang);
        setIsOpen(false); // Закрыть список после выбора
    };


    return (
        <header className="header">
            <div className="slider__controls">
                {currentIndex > 0 && ( // Проверяем, чтобы кнопка скрывалась на первом слайде
                    <button
                        onClick={prevSlide}
                        style={{
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        <IoIosArrowBack style={{ width: '50px', height: '50px' }} />
                    </button>
                )}
            </div>

            <div className="header__title">
                    <h1>
                        <Translate id={h1TextId} />
                    </h1>
                    <p><Translate id={h1DescriptionId}/></p>
            </div>
            <div className="header__language-selector">
                <button
                    className="header__language-btn"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <img src={languages[selectedLang].flag} alt={selectedLang} className="header__flag" />
                </button>

                {isOpen && (
                    <div className="header__dropdown">
                        {Object.keys(languages).map((lang) => (
                            <button
                                key={lang}
                                className="header__dropdown-item"
                                onClick={() => handleLanguageChange(lang)}
                            >
                                <img src={languages[lang].flag} alt={lang} className="header__flag" />
                                {languages[lang].label}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;